"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CameraOff = function CameraOff(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 5h.4189c.1334 0 .2 0 .2605-.0037A2 2 0 0 0 7.414 3.746c.0226-.0561.0437-.1194.0859-.246s.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C9.381 2 9.4477 2 9.5811 2h4.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246s.0633.1899.0859.246a2 2 0 0 0 1.7347 1.2503C18.381 5 18.4521 5 18.5944 5c.3692 0 .5539 0 .7014.0146 1.4229.141 2.5486 1.2667 2.6896 2.6896.0146.1475.0146.3227.0146.673V18c0 1.0849-.5759 2.0353-1.4387 2.5622m-5.4972-5.4908A3.984 3.984 0 0 0 16 12.5c0-2.2091-1.7909-4-4-4a3.984 3.984 0 0 0-2.5699.9346M22 22 2 2m0 5.5v8.7c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21h8.7M12 16.5c-2.2091 0-4-1.7909-4-4"
    })
  }));
};
var _default = exports["default"] = CameraOff;